import { useSelector } from "react-redux";
import styled from "styled-components";
import ButtonArrow from "~/components/ButtonArrow";
import ButtonOutline from "~/components/ButtonOutline";
import BuyButton from "~/components/BuyButton";
import LinkButton from "~/components/LinkButton";
import MediaFull from "~/components/MediaFull";
import SoundProfile from "~/components/SoundProfile";
import Spacer from "~/components/Spacer";
import { imageUrl } from "~/external/commercetools";
import { paragraph } from "~/styles/mixins";
import theme, { rem } from "~/styles/theme";

const Item = styled.div`
  /* margin-top: ${(p) => p.theme.sizes.topBarHeight}rem; */
  /* background-color: tomato; */
  display: flex;
  flex-direction: column;
  height: 100%;

  overflow: hidden;
`;

const InfoTop = styled.div`
  color: ${(p) => p.color || p.theme.colors.dark};
  /* flex: 1; */
  h3 {
    margin: 0;
    padding: 0;
    font-size: ${rem("30px")};
    font-weight: normal;
    margin-bottom: ${(p) => p.theme.sizes.vSpacing}rem;
  }

  h4 {
    margin: 0;
    padding: 0;
    font-size: ${rem("16px")};
    /* font-family: 'RelativeFaux'; */
    font-family: "AIAIAI";
    font-weight: normal;
    margin-bottom: ${(p) => p.theme.sizes.vSpacing * 5}rem;
  }
`;

const InfoBottom = styled.div`
  /* padding: ${(p) => p.theme.sizes.vSpacing * 2}rem 0; */
  padding-top: ${(p) => p.theme.sizes.vSpacing * 2}rem;
  flex: 1;
  color: ${(p) => p.color || p.theme.colors.dark};
`;

const TextWrapper = styled.div`
  p {
    ${paragraph};
    max-width: ${(p) => p.maxWidth || "none"};
  }
`;

const Text = styled.div`
  line-height: 1.6em;
  font-size: ${rem("16px")};
`;

const SoundProfileWrapper = styled.div`
  position: absolute;
  left: ${(p) => p.theme.sizes.hSpacing * 1.1}rem;
  bottom: ${(p) => p.theme.sizes.vSpacing * 0.75}rem;
`;

function Card(props) {
  let {
    type = "a",
    media,
    title,
    subtitle,
    text,
    color,
    buttonText,
    buttonType,
    buttonAlignment,
    buttonAction = "link",
    buttonHidden = false,
    href,
    hrefAs,
    hrefTarget,
    product,
    variantKey,
    // variant,
    showProductPrice = false,
    allClickable = true,
    buttonSpacing = 8,
    lazy = true,
    soundProfile,
    skipCrossSells = false,
    showText = true,
  } = props;

  const countryData = useSelector((s) => s.countryData);

  // if (!soundProfile) {
  //   // prettier-ignore
  //   soundProfile = JSON.parse(`{"title":"S01-E02","subtitle":"Light and forward","excerpt":[{"type":"paragraph","text":"","spans":[]}],"description":[{"type":"paragraph","text":"This configuration provides a balanced sound with a distinct low-end and dynamic high-end. Intimate sound and high isolation.","spans":[]}],"frequency_low":-0.33,"frequency_mid":0,"frequency_high":0.33,"speaker_units":{"id":"XYUugBAAACIATCXj","type":"product","tags":["modular-part","speaker-units"],"slug":"s01---speaker-units","lang":"en-us","uid":"s01","link_type":"Document","isBroken":false},"earpads":{"id":"XZM0OhAAACYALsdP","type":"product","tags":["modular-part","earpads"],"slug":"e02---earpads","lang":"en-us","uid":"e02","link_type":"Document","isBroken":false},"response_curve_data":"[[19.5,68],[20.1,68.5],[20.6,68.9],[21.2,69.3],[21.9,69.7],[22.5,70.1],[23.2,70.5],[23.8,70.9],[24.5,71.2],[25.3,71.6],[26,72],[26.8,72.4],[27.5,72.8],[28.4,73.2],[29.2,73.6],[30,74],[30.9,74.3],[31.8,74.6],[32.8,74.9],[33.7,75.2],[34.7,75.4],[35.7,75.6],[36.8,75.8],[37.9,76.1],[39,76.3],[40.1,76.4],[41.3,76.6],[42.5,76.7],[43.7,76.7],[45,76.7],[46.3,76.7],[47.7,77],[49.1,77.4],[50.5,77.5],[52,77.5],[53.5,77.5],[55.1,77.5],[56.7,77.5],[58.4,77.5],[60.1,77.5],[61.8,77.4],[63.7,77.4],[65.5,77.4],[67.4,77.5],[69.4,77.6],[71.5,77.6],[73.5,77.7],[75.7,77.7],[77.9,77.7],[80.2,77.8],[82.6,77.9],[85,77.9],[87.5,77.9],[90,77.8],[92.7,77.8],[95.4,77.9],[98.2,78],[101,77.9],[104,78],[107,78],[110,78],[113,78],[117,78],[120,78],[124,78],[127,78],[131,78],[135,77.9],[139,78],[143,78],[147,78],[151,78.1],[156,78],[160,77.7],[165,77.8],[170,77.9],[175,77.8],[180,77.7],[185,77.7],[191,77.8],[196,77.9],[202,77.9],[208,77.9],[214,77.9],[220,78.1],[227,78.2],[234,78.3],[240,78.4],[247,78.5],[255,78.6],[262,78.6],[270,78.5],[278,78.6],[286,78.8],[294,79],[303,79.2],[312,79.3],[321,79.4],[330,79.5],[340,79.7],[350,79.8],[360,80],[371,80.1],[382,80.3],[393,80.5],[404,80.7],[416,80.8],[428,81],[441,81.3],[454,81.5],[467,81.7],[481,81.8],[495,82],[509,82.1],[524,82.2],[540,82.2],[555,82.1],[572,81.9],[588,81.7],[606,81.5],[623,81.3],[642,81.1],[660,80.9],[680,80.7],[700,80.6],[720,80.5],[741,80.4],[763,80.3],[785,80.2],[808,80.2],[832,80.2],[856,80.3],[882,80.4],[907,80.6],[934,80.8],[961,81.1],[990,81.4],[1019,81.6],[1048,81.8],[1079,81.9],[1111,82.1],[1143,82.2],[1177,82.3],[1211,82.3],[1247,82.3],[1283,82.2],[1321,81.2],[1360,79.5],[1399,79.9],[1440,80.2],[1483,80.2],[1526,79.9],[1571,79.6],[1617,79.3],[1664,79.1],[1713,79],[1763,78.9],[1815,79],[1868,78.8],[1923,78.8],[1979,78.5],[2037,78.6],[2097,78.9],[2158,79.3],[2221,79.7],[2287,80.2],[2354,80.7],[2423,81.1],[2494,81.8],[2567,82.6],[2642,83.1],[2719,83.8],[2799,84.6],[2881,84.5],[2965,85],[3052,85.7],[3142,86.4],[3234,87],[3328,87.2],[3426,86.8],[3526,86.5],[3630,87.6],[3736,89.9],[3846,93.8],[3958,97.3],[4074,98.7],[4194,99.8],[4316,101.7],[4443,103.8],[4573,103.8],[4707,100],[4845,95.2],[4987,92],[5133,90.6],[5284,89.5],[5438,90.7],[5598,91.9],[5762,91.8],[5931,90.8],[6104,89.5],[6283,88.3],[6467,87],[6657,86],[6852,85.4],[7053,84.8],[7259,84.4],[7472,84.5],[7691,84.9],[7916,84],[8148,82],[8387,79.6],[8633,77.8],[8886,76],[9146,74.1],[9414,71.9],[9690,69.2],[9974,66.3],[10266,63],[10567,63.2],[10877,69.8],[11196,73.5],[11524,75.1],[11861,75.9],[12209,76],[12567,75.8],[12935,75.6],[13314,74.8],[13704,73.6],[14105,73],[14519,71.8],[14944,71],[15382,70.3],[15833,68.2],[16297,63.5],[16774,64.5],[17266,65.1],[17772,64.4],[18293,62],[18829,59.2],[19380,56.8]]"}`);
  // }

  if (hrefAs === undefined) hrefAs = href;

  // disable links if buttonType === 'hidden!
  if (buttonType === "hidden") {
    allClickable = false;
  }

  // find the variantIndex! either use master, or variantKey if provided
  let variantIndex = -1;
  if (variantKey)
    variantIndex = product.variants.findIndex((v) => v.key === variantKey);
  if (variantIndex === -1) {
    variantIndex = product ? product.masterVariantIndex : 0;
    // make sure variantKey is undefined.. just in case someone wrote wrong keu
    variantKey = undefined;
  }

  // extract the variant!
  let variant = product
    ? product.masterVariant || product.variants[variantIndex]
    : null;

  if (variant) {
    variant = { ...variant, ...product };
  }

  // get title from variant
  if (!title && product) {
    title = variant?.tagline ? (
      <>
        <strong>{variant.key.toUpperCase()}</strong> · {variant.tagline}
      </>
    ) : (
      product.name
    );
  }

  // get text from variant
  if (showText && !text && product) {
    text = <p>{product.description}</p>;
  }

  // get image from variant
  if (!media && variant) {
    if (variant.images.length > 0) {
      if (variant.images[0].url) {
        media = [
          imageUrl(variant.images[0].url, "main"),
          "image",
          variant.images[0].dimensions.width,
          variant.images[0].dimensions.height,
        ];
      }
    }
  }

  if (!buttonText) {
    buttonText = "Read more";

    // Override for products
    if (variant) {
      buttonText = "Shop now";
      if (buttonAction === "buy") buttonText = "Add to cart";

      // Override for HK warehouse shipping
      if (countryData.channelKey === "hk" && !variant.bundle) {
        buttonText = `Learn more`;
        showProductPrice = false;
      }
    }
  }

  let buttonComponent = null; // aka. hidden
  switch (buttonType) {
    case "outlined":
      buttonComponent = ButtonOutline;
      break;
    case "arrow":
      buttonComponent = ButtonArrow;
      break;
  }

  // only show spacing underneath, if we have a button!
  const hasButton =
    buttonComponent &&
    ((buttonAction === "link" && (href || variant)) || buttonAction === "buy");

  if (!subtitle && variantKey) {
    subtitle = <span style={{ textTransform: "capitalize" }}>{variantKey}</span>;
  }

  if (!showText) {
    buttonSpacing /= 2;
  }

  return (
    <Item>
      {type === "b" && (
        <InfoTop color={color}>
          {title && <h3>{title}</h3>}
          {/* {subtitle && <h4>{subtitle}</h4>} */}
        </InfoTop>
      )}
      <div style={{ position: "relative" }}>
        {/* Only output if media is set */}
        {media && (
          <MediaFull
            lazy={lazy}
            hoverable
            media={media}
            noPadding
            backgroundColor={theme.colors.greyLighter}
            clickable={allClickable}
            href={href}
            as={hrefAs}
            target={hrefTarget}
            variant={variant}
          />
        )}
        {soundProfile && (
          <SoundProfileWrapper>
            <SoundProfile soundProfile={soundProfile} small />
          </SoundProfileWrapper>
        )}
      </div>

      <InfoBottom color={color}>
        <Text>
          {type === "a" && (
            <div>
              {title && <span style={{ fontWeight: "bold" }}>{title}</span>}
              {subtitle && <span> · {subtitle}</span>}
            </div>
          )}
          {text && <TextWrapper>{text}</TextWrapper>}
        </Text>
        {hasButton && buttonSpacing > 0 && (
          <Spacer backgroundColor="transparent" size={buttonSpacing} />
        )}
      </InfoBottom>

      {/* {buttonActionType === 'buy' && !forceHideButton && (
        <BuyButton buttonComponent={ButtonOutline} product={product} />
      )} */}

      {!buttonHidden &&
        buttonComponent &&
        buttonAction === "link" &&
        (href || variant) && (
          <LinkButton
            buttonComponent={buttonComponent}
            buttonProps={{ color }}
            href={href}
            as={hrefAs}
            target={hrefTarget}
            buttonText={buttonText}
            variant={variant}
            includePrice={showProductPrice}
            alignment={buttonType == "arrow" ? buttonAlignment : null}
          />
        )}

      {!buttonHidden && buttonComponent && buttonAction === "buy" && (
        <BuyButton
          // product={product}
          variant={variant}
          buttonProps={{ color }}
          buttonComponent={buttonComponent}
          customButtonText={buttonText}
          includePrice={showProductPrice}
          skipCrossSells={skipCrossSells}
          // alignment={buttonAlignment}
        />
      )}
    </Item>
  );
}

export default Card;
